import { create } from './hostRatingService'

const state = {
  isCreatingHostRating: false,
}

const getters = {
  isCreatingHostRating: (state) => state.isCreatingHostRating,
}

const actions = {
  async createHostRating({ commit, dispatch }, rating) {
    commit('setIsCreatingHostRating', true)

    try {
      await create(rating)
      window.location.replace('/host-rate')
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsCreatingHostRating', false)
    }
  }
}

const mutations = {
  setIsCreatingHostRating: (state, status) => {
    state.isCreatingHostRating = status
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
}
